export const categorylist = [
  {
    id: 1,
    title: "色情低俗",
    desc: "",
  },
  {
    id: 2,
    title: "违法犯罪",
    desc: "",
  },
  {
    id: 3,
    title: "诈骗行为",
    desc: "",
  },
  {
    id: 4,
    title: "骚扰攻击",
    desc: "",
  },
  {
    id: 5,
    title: "广告内容",
    desc: "",
  },
  {
    id: 6,
    title: "青少年不宜",
    desc: "",
  },
  {
    id: 7,
    title: "时政不实",
    desc: "",
  },
  {
    id: 8,
    title: "涉嫌网络暴力",
    desc: "",
  },
  {
    id: 9,
    title: "其他违规",
    desc: "",
  },
];
